import React from 'react';
import { Download } from 'lucide-react';

interface ExportButtonProps {
  data: any[];
  filename?: string;
  headers?: { key: string; label: string }[];
  className?: string;
}

export const ExportButton: React.FC<ExportButtonProps> = ({
  data,
  filename = 'export.csv',
  headers,
  className = '',
}) => {
  const convertToCSV = (objArray: any[]) => {
    if (objArray.length === 0) return '';

    const targetHeaders = headers || Object.keys(objArray[0]).map((key) => ({ key, label: key }));
    const headerRow = targetHeaders.map((h) => `"${h.label.replace(/"/g, '""')}"`).join(',');

    const rows = objArray.map((row) => {
      return targetHeaders
        .map((h) => {
          const val = row[h.key];
          const valStr =
            val === null || val === undefined
              ? ''
              : typeof val === 'object'
                ? JSON.stringify(val)
                : String(val);
          return `"${valStr.replace(/"/g, '""')}"`;
        })
        .join(',');
    });

    return [headerRow, ...rows].join('\r\n');
  };

  const handleExport = () => {
    const csvContent = convertToCSV(data);
    const blob = new Blob([new Uint8Array([0xef, 0xbb, 0xbf]), csvContent], {
      type: 'text/csv;charset=utf-8;',
    });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.setAttribute('href', url);
    link.setAttribute('download', filename);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <button
      onClick={handleExport}
      disabled={data.length === 0}
      className={`btn-base btn-sm btn-secondary flex items-center gap-2 ${className}`}
    >
      <Download className="w-4 h-4" />
      <span>Exportar CSV</span>
    </button>
  );
};
